<template>
<div class="input-date-picker">
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field
                class="input-date-picker__form"
                :class="{
                          'input-date-picker__form-disabled': disabled
                        }"
                :rules="rules"
                :value="dateFormatted"
                outlined
                readonly
                :disabled="disabled"
                v-on="on">
                <template v-slot:append>
                    <v-icon
                        :disabled="disabled"
                        class="input-date-picker__icon"
                        v-on="on">mdi-calendar-blank</v-icon>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            type="month"
            v-model="date"
            no-title
            scrollable
            locale="ru-ru"
            :allowed-dates="getAllowedDates"
            min="2000-03">
            <v-spacer></v-spacer>
            <v-btn
                text
                color="primary"
                @click="menu = false">Отмена</v-btn>
        </v-date-picker>

    </v-menu>
</div>
</template>

<script>
export default {
    name: 'InputMonthPicker',
    model: {
        props: 'value',
        event: 'change'
    },
    props: ['value', 'disabled', 'min', 'max', 'rules'],
    data: () => ({
        date: null,
        dateFormatted: null,
        menu: false,
    }),
    watch: {
        date(val) {
            if (val) {
                let resultdate = new Date(val);
                if ((!this.min || this.min <= resultdate.getTime()) && (!this.max || this.max >= resultdate.getTime())) {
                    this.$refs.menu.save(val);
                    this.dateFormatted = val ? this.formatDate(val) : '';
                    this.$emit('change', val);
                }
            } else {
                this.dateFormatted = null
            }
        },
        value: {
            immediate: true,
            handler: function (val) {
                this.date = val ? new Date(val).toISOString().substr(0, 10) : null;
            }
        }
    },

    methods: {
        formatDate(date) {
            if (!date) return null;

            const [y, m, d] = date.split('-');
            const month = new Date(y, m - 1, d).toLocaleString('default', {
                month: 'long'
            });

            return `${month[0].toUpperCase() + month.slice(1)}, ${y}`;

        },
        getAllowedDates: val => 
       ((val.split('-')[1] <= new Date().getMonth()  === true)&& (val.split('-')[0] < new Date().getFullYear() + 1 === true)) 
       ||(val.split('-')[0] < new Date().getFullYear() === true) ,
    }
};
</script>

<style lang="scss">
.input-date-picker {
    &__form:hover &__icon:not([disabled]) {
        color: $main-orange;
    }

    .input-date-picker__form.input-date-picker__form-disabled fieldset {
        border-color: rgba(0, 0, 0, 0.24) !important;
    }
}
</style>
